import React from "react";
import "./setting.css";
import Header from "../../components/header/Header";
// import toast from "react-hot-toast";

const Setting = () => {
	return (
		<div className="action__page">
			<Header />
			<div className="setting__page__heading">SETTINGS</div>
			<div className="setting">
				<div className="setting__card-wrapper">
					<div className="setting__card-container">
						<div className="setting__card--header">CHANGE PASSWORD</div>
						<div className="setting__card">
							<div className="setting__card-inside">
								<textarea placeholder="Input Your New Password" />
							</div>
						</div>
					</div>

					<div className="setting__card-container">
						<div className="setting__card--header">LOAN APPLICATION</div>
						<div className="setting__card">
							<div className="setting__card-inside">
								<textarea placeholder="Coming Soon..." />
							</div>
						</div>
					</div>

					<div className="setting__card-container">
						<div className="setting__card--header">UPLOAD CREDENTIALS</div>
						<div className="setting__card">
							<div className="setting__card-inside">
								<div className="setting__card-upload_btn ">Upload Credentials</div>
							</div>
						</div>
					</div>
					<div className="setting__card-container">
						<div className="setting__card--header">LEAVE APPLICATION</div>
						<div className="setting__card">
							<div className="setting__card-inside">
								<textarea placeholder="Coming Soon..." />
							</div>
						</div>
					</div>
				</div>
				<div className="action-btns">
					<button>SAVE</button>
				</div>
			</div>
		</div>
	);
};

export default Setting;
